import {PRIVATE_ENDPOINTS} from '@/constants/api'
import {deleteData, getData, getExternalData, patchData, postData} from '@/services/api'

/**
 * 👥 User API Service
 */
export const UserService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.user.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.user.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.user.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.user.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.user.delete(id)),
}

/**
 * 📊 Analysis API Service
 */
export const AnalisiService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.analysis.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.analysis.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.analysis.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.analysis.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.analysis.delete(id)),
}

/**
 * 🌆 City API Service
 */
export const CityService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.city.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.city.single(id)),
}

/**
 * 📌 Login API Service
 */
export const LoginService = {
  login: (data: object) => postData(PRIVATE_ENDPOINTS.auth.login, data),
}

/**
 * 🌐 Geocoding API Service
 */
export const GeocodingService = {
  getCoordinates: (
    address_number: string | null,
    street: string | null,
    postcode: string | null,
    place: string | null,
  ) => {
    const params = new URLSearchParams()

    if (address_number) params.append('address_number', address_number)
    if (street) params.append('street', street)
    if (postcode) params.append('postcode', postcode)
    if (place) params.append('place', place)

    params.append('country', 'Italy')
    params.append('autocomplete', 'false')
    params.append('limit', '1')
    params.append('access_token', import.meta.env.VITE_MAPBOX_ACCESS_TOKEN)

    const url = `https://api.mapbox.com/search/geocode/v6/forward?${params.toString()}`
    return getExternalData(url)
  },
}
